import type { Routes } from '@angular/router';
import { authGuard } from '@features/identity/guards/auth.guard';
import { pageGuard } from '@features/identity/guards/page.guard';
import { provideTranslocoScope } from '@jsverse/transloco';

export const routes: Routes = [
    {
        path: 'app',
        canActivate: [authGuard],
        canActivateChild: [pageGuard],
        loadComponent: () => import('./shared/components/layout/layout').then((m) => m.Layout),
        children: [
            {
                path: '',
                loadChildren: () => import('./features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
            },
            {
                path: 'cliente',
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/dashboard-cliente/dashboard-cliente.routes').then(
                                (m) => m.DASHBOARD_CLIENTE_ROUTES,
                            ),
                    },
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/consumo/consumo.routes').then((m) => m.MIS_CONSUMOS_ROUTES),
                    },
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/recargas/recargas.routes').then((m) => m.MIS_RECARGAS_ROUTES),
                    },
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/billing-config/billing-config.routes').then(
                                (m) => m.BILLING_ALERTA_ROUTES,
                            ),
                    },
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/prevalidacion/prevalidacion.routes').then((m) => m.PREVALIDACION_ROUTES),
                    },
                    {
                        path: '',
                        loadChildren: () => import('./features/unidades/unidad.routes').then((m) => m.UNIDADES_ROUTES),
                    },
                ],
            },
            {
                path: 'facturacion',
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/paquetes/paquetes.routes').then((m) => m.PAQUETES_ROUTES),
                    },
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/billing-config/billing-config.routes').then(
                                (m) => m.BILLING_CONFIG_ROUTES,
                            ),
                    },
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/ajuste-saldo/ajuste-saldo.routes').then((m) => m.AJUSTE_SALDO_ROUTES),
                    },
                    {
                        path: '',
                        loadChildren: () => import('./features/consumo/consumo.routes').then((m) => m.CONSUMO_ROUTES),
                    },
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/recargas/recargas.routes').then((m) => m.RECARGAS_ROUTES),
                    },
                ],
            },
            {
                path: '',
                loadChildren: () => import('./features/aduanas/aduanas.routes').then((m) => m.ADUANAS_ROUTES),
            },
            {
                path: '',
                loadChildren: () => import('./features/emails/emails.routes').then((m) => m.EMAILS_ROUTES),
            },
            {
                path: '',
                loadChildren: () => import('./features/reportes/reportes.routes').then((m) => m.REPORTES_ROUTES),
            },
            {
                path: 'catalogos',
                children: [
                    {
                        path: '',
                        loadChildren: () => import('./features/marcas/marcas.routes').then((m) => m.MARCAS_ROUTES),
                    },
                    {
                        path: '',
                        loadChildren: () => import('./features/modelos/modelos.routes').then((m) => m.MODELOS_ROUTES),
                    },
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/fracciones/fracciones.routes').then((m) => m.FRACCIONES_ROUTES),
                    },
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/relacion-aduanas/relacion-aduanas.routes').then(
                                (m) => m.RELACION_ADUANAS_ROUTES,
                            ),
                    },
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/localidades/localidades.routes').then((m) => m.LOCALIDADES_ROUTES),
                    },
                    {
                        path: '',
                        loadChildren: () => import('./features/paises/paises.routes').then((m) => m.PAISES_ROUTES),
                    },
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/entidades/entidades.routes').then((m) => m.ENTIDADES_ROUTES),
                    },
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/transportistas/transportistas.routes').then(
                                (m) => m.TRANSPORTISTAS_ROUTES,
                            ),
                    },
                ],
            },
            {
                path: 'seguridad',
                children: [
                    {
                        path: '',
                        loadChildren: () => import('./features/users/users.routes').then((m) => m.USERS_ROUTES),
                    },
                    {
                        path: '',
                        loadChildren: () => import('./features/modules/modules.routes').then((m) => m.MODULES_ROUTES),
                    },
                    {
                        path: '',
                        loadChildren: () => import('./features/roles/roles.routes').then((m) => m.ROLES_ROUTES),
                    },
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/feature-flags/feature-flags.routes').then(
                                (m) => m.FEATURE_FLAGS_ROUTES,
                            ),
                    },
                ],
            },
            {
                path: 'mantenimiento',
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('./features/mantenimiento/mantenimiento.routes').then((m) => m.MANTENIMIENTO_ROUTES),
                    },
                ],
            },
            {
                path: 'sat',
                providers: [provideTranslocoScope({ scope: 'sat' })],
                loadChildren: () => import('./features/sat-q/sat-q.routes').then((m) => m.SAT_Q_ROUTES),
            },
        ],
    },
    {
        path: 'perfil',
        canActivate: [authGuard],
        providers: [provideTranslocoScope({ scope: 'identity' })],
        loadComponent: () => import('./shared/components/layout/layout').then((m) => m.Layout),
        children: [
            {
                path: '',
                title: 'identity.profile.title',
                loadComponent: () => import('./features/identity/pages/profile/profile').then((m) => m.Profile),
            },
        ],
    },
    {
        path: '',
        providers: [provideTranslocoScope({ scope: 'identity' })],
        loadChildren: () => import('./features/identity/identity.public.routes').then((m) => m.IDENTITY_PUBLIC_ROUTES),
    },
    {
        path: '',
        redirectTo: '/iniciar-sesion',
        pathMatch: 'full',
    },
    {
        path: '**',
        providers: [provideTranslocoScope({ scope: 'identity' })],
        loadComponent: () => import('./features/identity/pages/not-found/not-found').then((m) => m.NotFound),
        title: 'identity.notFound.title',
    },
];
